import styled from "@emotion/styled";
import { Popper } from "@mui/base/Popper";
import { sdkTouchOptimizedStyles } from "scmp-sdk/components/follow-button/styles";

import { fontRoboto, ZIndexLayer } from "shared/lib/styles";

import IconTick from "./icon-tick.svg";

export const StyledIconTick = styled(IconTick)``;

export const Button = styled.button`
  padding: 0;

  color: inherit;
  font: inherit;

  border: none;

  background-color: transparent;

  cursor: pointer;

  .copied {
    display: flex;
    align-items: center;

    padding-block: 4px;
    padding-inline: 6px;

    color: #ffffff;
    font-weight: 700;

    background-color: #000000;
  }

  ${sdkTouchOptimizedStyles}
`;

export const StyledPopper = styled(Popper)`
  z-index: ${ZIndexLayer.Tooltip};
`;

export const Tooltip = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;

  inline-size: 114px;
  block-size: 32px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;
  text-align: center;

  background-color: #000000;
`;
